import { FieldSet } from "../utils/ui/FieldSet";

export class InsetBayFieldSet extends FieldSet
{
    constructor(config: any, orderId: number)
    {
        super({
            label: config.label,
            fields: config.fields.array,
            orderId: orderId
        }, null);
    }
}